import { defineStore } from "pinia"
import { EventSourcePolyfill } from 'event-source-polyfill'
import axiosInstance from "@/utils/http.js"
const axios = axiosInstance


export const CLEARFXAI_API_URL = "https://go.clearfxai.com"

export const DEVSAFRA_API_URL = process.env.VUE_APP_DEVSAFRA_API_URL
export const APIKEY = process.env.VUE_APP_APIKEY
export const SECRETKEY = process.env.VUE_APP_SECRETKEY
export const APIVERSION = process.env.VUE_APP_API_VERSION
export const APP_PROD = process.env.VUE_APP_PROD

export const API_PATH = `apiv1.3/cfxai`
export const API_PATH_REST = `v1/clearfxai/`

export let AUTH_PATH = `apiauth/${API_PATH}`
export let SANDBOX_PATH = `apisandbox/v${APIVERSION}`
export let ALGO_RFQ_PATH = `${SANDBOX_PATH}/algorfq`
export let ENTITY_PATH = `apientity/${API_PATH}`
export let MARKET_PATH = `${API_PATH}/fxmarket/${API_PATH_REST}`
export let RISK_PATH = `risk/${API_PATH}`
export let REPORT_PATH = `report/${API_PATH}`
export let DASHBOARD_PATH = `dashboard/${API_PATH}`
export let MOCK_PRICER_PATH = `mock_pricer/${API_PATH}`
export let PRICER_PATH = `pricer/${API_PATH}`
export let CONSOLE_PATH = `apiconsole/${API_PATH}`
export let MOCK_CONSOLE_PATH = `mock_apiconsole/${API_PATH}`
export let RFQ_PATH = `rfq/${API_PATH}`
export let TLS_PATH = `apitls`
export let MOCK_TLS_PATH = `mockapitls`

// if (process.env.NODE_ENV === "development") {
// }

export const useColorsStore = defineStore("utils", {
  state: () => ({
    orangeColor: "#FF6D00", // "#FFD600", // "#FB8C00",
    aliveColor: "#00c853",
    yellowTransp: "#4b2000", // "#816c00" // "#633b01"
    aliveTransp: "#003817"
  }),
  actions: {},
});


export const useDisplayStore = defineStore("display", {
  state: () => ({
    breakpoint: undefined,
    windowHeight: window.innerHeight,
    headerHeight: 153,
    // footerHeight: 30,
    marginLayout: 32,
  }),
  getters: {
    isMobile() {
      return this.mobile
    },
    currentBreakpoint () {
      return this.breakpoint
    },
    isXLarge () {
      return this.currentBreakpoint === "xl"
    },
    isLarge () {
      return this.currentBreakpoint === "lg"
    },
    isMedium () {
      return this.currentBreakpoint === "md"
    },
    isSmall () {
      return this.currentBreakpoint === "sm"
    },
    isXSmall () {
      return this.currentBreakpoint === "xs"
    },
    contentHeight () {
      const contentHeight = 
        this.windowHeight 
        - this.headerHeight 
        // - this.footerHeight 
        // - this.marginLayout // x axis
        // - this.marginLayout // y axis
      return `${contentHeight}`
    },
  },
  actions: {
  }
})

export const useAlgoStore = defineStore("algo",  {
  state: () => ({}),
  getters: {},
  actions: {
      newRfq (data) {
      const authStore = useAuthStore()
      const apikey = authStore.getApiKey
      const url = `${CLEARFXAI_API_URL}/${ALGO_RFQ_PATH}/new`
      return axios.post(url, data, {
        headers: {
          APIKEY: apikey
        }
      })
    },
    declineQuoteOrder (rfqid) {
      const authStore = useAuthStore()
      const apikey = authStore.getApiKey
      const url = `${CLEARFXAI_API_URL}/${ALGO_RFQ_PATH}/decline?rfqid=${rfqid}`
      return axios.delete(url, {
        headers: {
          APIKEY: apikey
        }
      })
    },
    getQuote (rfqId) {
      const authStore = useAuthStore()
      const apikey = authStore.getApiKey
      const url = `${CLEARFXAI_API_URL}/${ALGO_RFQ_PATH}/quote/${rfqId}`
      return axios.get(url, {
        headers: {
          APIKEY: apikey
        }
      })
    },
    order (payload) {
      const authStore = useAuthStore()
      const apikey = authStore.getApiKey
      const url = `${CLEARFXAI_API_URL}/${ALGO_RFQ_PATH}/order`
      return axios.post(url, payload, {
        headers: {
          APIKEY: apikey
        }
      })
    },
    async orderList (count) {
      const authStore = useAuthStore()
      await authStore.getAPIKey()
      const apikey = authStore.getApiKey
      const url = `${CLEARFXAI_API_URL}/apisandbox/v1/rfqdb/order/list?count=${count}`
      return axios.get(url, {
        headers: {
          APIKEY: apikey
        }
      })
    },
    quoteOnceRfqOcta (data) {
      const url = `${RFQ_PATH}/quoteonce/${data}`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
  }
})

export const useCalendarStore = defineStore("calendar", {
  state:()=>({
    calendarCountriesFilters: [],
    calendarImportanceFilters:[],
  }),
  getters:{
    getCalendarFilters(){
      return this.calendarCountriesFilters
      },
    },
   actions: {
    setCalendarFilters(filters, type)
    {
      if(type === 'country')
      {
        this.calendarCountriesFilters.includes(filters) ? 
          this.calendarCountriesFilters=this.calendarCountriesFilters.filter(c=>c !== filters) : 
           this.calendarCountriesFilters.push(filters)
      }
      else if(type === 'importance')
      {
        this.calendarImportanceFilters.includes(filters) ? 
          this.calendarImportanceFilters=this.calendarImportanceFilters.filter(c=>c !== filters) : 
           this.calendarImportanceFilters.push(filters)
      }
      
      
    },
    resetCalendarFilter()
    {
      this.calendarCountriesFilters = []
      this.calendarImportanceFilters = []
    },
    setCalendarFilterList(list, type)
    {
      if(type === 'country')
      {
        this.calendarCountriesFilters = list
      }
      else if(type === 'importance')
      {
        this.calendarImportanceFilters = list
      }
    }
  }

})

export const useSettingsStore = defineStore("settings", {
  state: () => ({
    isMockDataOn: JSON.parse(localStorage.getItem('isMockDataOn')) ?? false,
    timezone: localStorage.getItem('userTimezone') || 'UTC',
    fontsize: localStorage.getItem('userFontSize') || 'MD',
    spreadType: localStorage.getItem('spreadType') || 'PIPS',
    isModalOn: false,
    isOverridePricer: [],
    vh:window.innerHeight,
  }),
  getters: {
    isUTC: (state) => state.timezone === 'UTC',
    isBRT: (state) => state.timezone === 'BRT',
    getOverridePricer: (state) => state.isOverridePricer,
    getSpreadType: (state) => state.spreadType,
    getFontSize:(state)=>{
      return state.fontsize === 'SM' ? 1 : state.fontsize === 'MD' ? 1.2 : 1.5
    },
    getVh: (state)=> state.vh
  },
  actions: {
    toggleMockData(value) {
      this.isMockDataOn = value
      localStorage.setItem('isMockDataOn', JSON.stringify(value))
    },
    formatScreenSize(){
      const screenSize = window.innerWidth;

      if (screenSize <= 900) return "mobile";
      if (screenSize <= 1250) return "tablet";
      if (screenSize <= 1270) return "smallScreen";
      return "full";
    },
    formatFontSize(screenSizeFormat) {
      if (screenSizeFormat === "mobile") {
        return this.getFontSize * "10" + "px";
      } else if (screenSizeFormat === "tablet") {
        return this.getFontSize * "12" + "px";
      } else if (
        screenSizeFormat === "full" ||
        screenSizeFormat === "smallScreen"
      ) {
        return this.getFontSize * "11" + "px";
      }
    },
  formatFileName(name,  isSmallScreen = false){
      const font = this.fontsize
      
      return  isSmallScreen ? `${name.slice(0, 30)}...` : name;

      //return name.length <= size ? name : name.slice(0,size).trim().concat("...")
    },
    formatCalendarTitle(name){
      const font = this.fontsize
      let maxLength = 0

        if(font === 'LG') maxLength = 20;
        else if(font === 'MD') maxLength = 55;
        else maxLength = 20;
      
        return name.length > maxLength ? `${name.slice(0, maxLength)}...`: name;
    },
    setDefaultTimerForRFQ(dataTimer)
    {
      const executionStore = useExecutionStore()
 
      executionStore.putBroker({'default_rfq_timer':  dataTimer.timer}, dataTimer.cnpj)

      const snack = useSnackbarStore()
      this.defaultTimerForRFQ = dataTimer.timer
      localStorage.setItem('defaultTimer', dataTimer.timer)
      snack.open('Saved!')
    },
    setTimezone(tz) {
      const snack = useSnackbarStore()
      this.timezone = tz
      localStorage.setItem('userTimezone', tz)
      snack.open('Saved!', 'green')
    },
    setFontSize(fs){
      const snack = useSnackbarStore()
      this.fontsize = fs
      localStorage.setItem('userFontSize', fs)
      snack.open('Saved!', 'green')
    },
    setSpreadType(type)
    {
      const executionStore = useExecutionStore()
      this.spreadType = type
      const cnpj = JSON.parse(localStorage.getItem('brokerCnpj'))
      localStorage.setItem('spreadType', type)
      const spreadBps = .5
      const spreadPips = 50
      executionStore.putBroker({'spread': spreadPips, 'spread_bps':spreadBps, 'spread_type' : this.getSpreadType}, cnpj)
    },
    setViewHeight(vh)
    {
      this.vh = vh
    },
    setOverridePricer(pricer)
    {
      const find = this.isOverridePricer.find(pri=>pri.bankName === pricer.bankName)
      if (find)
      {
        this.isOverridePricer = this.isOverridePricer.filter(pri=>pri.bankName !== pricer.bankName) 
      }
      else
      {
        this.isOverridePricer.push(pricer)
      }
    }
  }
})

export const useFxMarketStore = defineStore("fxMarket",  {
  state: () => ({
    settingsStore: useSettingsStore(),
    fxMarketIntradayData: undefined, // from AlphaVantage
    fxMarketNews: [], // from AlphaVantage
    fxMarketAvgPtax: undefined, // from Banco Central
    fxMarketDailyData: undefined, // from AlphaVantage
    fxMarketEconomicCalendar: [], // from TradingView,
  }),
  getters: {
    getFxMarketIntradayData: (state) => state.fxMarketIntradayData,
    getFxMarketNews: (state) => state.fxMarketNews,
    getFxMarketAvgPtax: (state) => state.fxMarketAvgPtax,
    getFxMarketDailyData: (state) => state.fxMarketDailyData,
    getFxMarketEconomicCalendar: (state) => state.fxMarketEconomicCalendar,
  },
  actions: {
    // broker marketdada
    getBrokerMarketdata (currencyPairs) {
      const params = currencyPairs.map(pair => `${pair.fromCcy}-${pair.toCcy}`).join(',');
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-broker-marketdata`
        : `${CLEARFXAI_API_URL}/${MARKET_PATH}/broker-marketdata`
      return axios.get(url,{
        params: {
          pairs: params
        }
      })
    },
    // fxMarketCrossQuotes
    getFxMarketDataQuarterMinute (currencyPairs) {
      const params = currencyPairs.map(pair => `${pair.fromCcy}-${pair.toCcy}`).join(',');
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-fx-market-data-quarter-minute`
        : `${CLEARFXAI_API_URL}/${MARKET_PATH}/fx-market-data-quarter-minute`
      return axios.get(url,{
        params: {
          pairs: params
        }
      })
    },
    getYesterdayTimeZone(){
      const d = new Date();
      d.setDate(d.getDate()-1);

      const yyyy= d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      return `${yyyy}${mm}${dd}T0000`
    },
    // fxMarketIntradayData and fxMarketNews
    getFxMarketDataMinutely (time_from) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-fx-market-data-minutely`
        : `${CLEARFXAI_API_URL}/${MARKET_PATH}/fx-market-data-minutely`
      return axios.get(url, {
        params: {
          time_from:time_from
        }
      })
    },
    // fxMarketAvgPtax, fxMarketDailyData and fxMarketEconomicCalendar
    getFxMarketDataHourly(from_date, to_date, countries, date_ptax) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-fx-market-data-hourly`
        : `${CLEARFXAI_API_URL}/${MARKET_PATH}/fx-market-data-hourly`
    
      return axios.get(url, {
        params: { from_date, to_date, countries, date_ptax }
      })
    },
    getFxMarketQuote(ticker) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/quote`
        : `${CLEARFXAI_API_URL}/${MARKET_PATH}/quote`
    
      return axios.get(url, {
        params: { ticker }
      })
    },
    getDollarRadar () {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/dollar-radar`
        : `${CLEARFXAI_API_URL}/${MARKET_PATH}/dollar-radar`
      return axios.get(url
      )
    },
    getHolidaysList() {
      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/get-holidays-list`
      return axios.get(url)
        .then(response => {
          if (response.status === 200 && response.data) {
            return response.data
          } 
        })
        .catch((error) => {
          console.log(error)
        })
    },
  }
})

export const useRiskStore = defineStore('risk', {
  state: () => ({
    settingsStore: useSettingsStore(),
    maturities: [],
    shouldRefreshMaturities: false
  }),
  getters: {
    formattedMaturities(state) {
      return state.maturities.map(item => {
        const amount = Number(item.Amount)

        return {
          ...item,
          formattedDate: (() => {
            const [year, month, day] = item.Date.split('-')
            return `${day}/${month}/${year}`
          })(),
          receivable: amount > 0 ? amount : '-',
          payable: amount < 0 ? Math.abs(amount) : '-'
        }
      })
    }
  },
  actions: {
    getMaturities () {
      const url = this.settingsStore.isMockDataOn
        ? '/assets/cashFlowData.json'
        : `${CLEARFXAI_API_URL}/${RISK_PATH}/csv/data`
      return axios.get(url, {
        headers: {
          "APIKEY": SECRETKEY
        }
      })
    },
    getExposureData (exposure) {
      const url = exposure
        ? '/assets/cashFlowData.json'
        : '/assets/hedgeUSD.json'
      return axios.get(url)
        .then(response => {
          const data = response.data
          return data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    setShouldRefreshMaturities(value) {
      this.shouldRefreshMaturities = value
    },
    refreshMaturities () {
      return this.getMaturities()
        .then((response) => {
          const data = response.data
          this.maturities = data.data
    
          if (!this.settingsStore.isMockDataOn) {
            localStorage.setItem('lastRealMaturities', JSON.stringify(this.maturities))
          }
        })
    },
    saveMaturities (data) {
      const file = data.file
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/csv/import`
        : `${CLEARFXAI_API_URL}/${RISK_PATH}/csv/import`
      const bodyFormData = new FormData();
      bodyFormData.append("file", file);
      return axios.post(url, bodyFormData, {
        headers: {
          "APIKEY": SECRETKEY
        }
      })
    },
    downloadMaturities () {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/csv/export`
        : `${CLEARFXAI_API_URL}/${RISK_PATH}/csv/export`
      return axios.get(url, {
        headers: {
          "APIKEY": SECRETKEY
        },
        responseType: "arraybuffer"
      })
    },
    setMaturitiesFromStorage(data) {
      this.maturities = data
    }
  },
})

export const useExecutionStore = defineStore("execution", {
  state: () => ({
    settingsStore: useSettingsStore(),
    wasFileUploaded: false,
    selectedId: null,
  }),
  getters:{
    getSelectedId: (state) => state.selectedId,
  },
  actions: {
    setSelectedId(id){
      this.selectedId = id
    },
    getBrokerStats (broker_cnpj) {
      const url = this.settingsStore.isMockDataOn
       ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/broker_stats`
       : `${CLEARFXAI_API_URL}/${DASHBOARD_PATH}/broker_stats?broker_cnpj=${broker_cnpj}`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getActivePositions () {
      const url = this.settingsStore.isMockDataOn
       ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/active_positions`
       : `${CLEARFXAI_API_URL}/${DASHBOARD_PATH}/active_positions`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    // not used
    // getLiveRates () {
    //   const url = this.settingsStore.isMockDataOn
    //    ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/live_rates`
    //    : `${CLEARFXAI_API_URL}/${DASHBOARD_PATH}/live_rates`

    //   return axios.get(url, {
    //     headers: {
    //       SECRETKEY: SECRETKEY
    //     }
    //   })
    // },
    getTotalTransactedVolume () {
      const url = this.settingsStore.isMockDataOn
       ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/total_transacted_volume`
       : `${CLEARFXAI_API_URL}/${DASHBOARD_PATH}/total_transacted_volume`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getDailyAverageVolume () {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/daily_average_volume`
        : `${CLEARFXAI_API_URL}/${DASHBOARD_PATH}/daily_average_volume`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getMonthlyRevenue () {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/monthly_revenue`
        : `${CLEARFXAI_API_URL}/${DASHBOARD_PATH}/monthly_revenue`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getCompaniesByBrokerId (brokerId) {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/broker_companies_by_id/${brokerId}`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getCompaniesByBankId (bankId) {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/bank_companies_by_id/${bankId}`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    createCompany (data) {
      data.cnpj = data.cnpj.replace(/\D/g, '')
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/company_create`

      return axios.post(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
      convertCurrencyToNumber (currencyString) {
      if (typeof currencyString === 'string') {
        return parseFloat(currencyString.replace(/[^0-9.-]+/g,""));
      } else {
        return 0.00
      }
    },
    transformBrokerCompaniesToClients(list = []) {
      return list.map(item => {
        const bankArray = Array.isArray(item.banklist)
          ? item.banklist
              .filter(b => b && (b.name))
              .map(b => ({
                name: b.name,
                limit: Number(b.limit) || 0,
                id: b.id
              }))
          : []
        const user = item.user || {}
        return {
          id: item.id || "",
          broker_id: item.broker || "",
          companyName: item.name || "",
          cnpj: item.cnpj || "",
          banklist: bankArray,
          status: item.blocked === 1 ? "Paused" : "Active",
          email: user.email || "",
          transactedVolume: item.transactedVolume || 0,
          revenue: item.revenue || 0,
          lastTrade: item.lastTrade,
          phone: "",
          companyRepresentative: user.name || ""
        }
      })
    },
    updateClientLastTrade (clientCnpj, brokerId, selectedQuote, amount, selectedSpread) {
    // getCompaniesByBrokerId is not a mock function
    // getBrokerClients is a mock function
    // TODO: When demo mode is enabled, adjust this function to use getBrokerClients.
    return this.getCompaniesByBrokerId(brokerId)
      .then(res => {
        const raw = res.data || []
        const clients = this.transformBrokerCompaniesToClients(raw)
        const index = clients.findIndex(c => c.cnpj === clientCnpj)
        if (index === -1) return clients

        const updatedClient = { ...clients[index] } // safer

        updatedClient.lastTrade = new Date().toISOString()

        const transactedVolume =
          selectedQuote.rfq_quote_px * this.convertCurrencyToNumber(amount)

        const revenueVolume =
          ((selectedSpread / 10000) * this.convertCurrencyToNumber(amount)) / 2

        updatedClient.transactedVolume =
          (Number(updatedClient.transactedVolume) || 0) + transactedVolume

        updatedClient.revenue =
          (Number(updatedClient.revenue) || 0) + revenueVolume

        const newClientsList = clients.map(c =>
          c.cnpj === clientCnpj ? updatedClient : c
        )
        if (!this.settingsStore.isMockDataOn) {
          return this.putCompany({
            cnpj: clientCnpj,
            broker: brokerId,
            lastTrade: updatedClient.lastTrade,
            transactedVolume: updatedClient.transactedVolume,
            revenue: updatedClient.revenue
          }).then(() => newClientsList)
        }

        return newClientsList
        })
    },
    updateClients (isMockDataOn, clients, brokerId = "00") {
      localStorage.setItem('clients', JSON.stringify(clients))
        if (isMockDataOn) {
          // for demo mode use brokerid = 00
          this.saveBrokerClients(clients, "00")
            .catch(error => {
              console.log(error)
            })
          return
        }
        this.saveBrokerClients(clients, brokerId)
          .catch(error => {
            console.log(error)
          })
    },
    putCompany (data) {
      const onlyNumberCnpj = data.cnpj.replace(/\D/g, '')
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/company_update/${onlyNumberCnpj}`

      return axios.put(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    deleteCompany (cnpj) {
      const onlyNumberCnpj = cnpj.replace(/\D/g, '')
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/company_delete/${onlyNumberCnpj}`

      return axios.delete(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    deleteCompanyByFlag(cnpj) {
      const onlyNumberCnpj = cnpj.replace(/\D/g, '')
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/company_update/${onlyNumberCnpj}`

      return axios.put(url,{deleted : 1},{
        headers:{SECRETKEY:SECRETKEY}
      })
    },
    getCompanyById (id) {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/company_lookup_by_id/${id}`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    async hashPayloadCreation(userCnpj)
    {
      const payload = JSON.stringify({
          userCnpj,
          documents:'terms',
          version: 'v1',
          acknowledgedAt: new Date().toISOString()
        })
        const msgBuffer = new TextEncoder().encode(payload);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        let wasHashed = {
          hashed: hashArray.map(b=>('00' + b.toString(16)).slice(-2)).join('')
        }

        return wasHashed;
    },
    async updateDBForHashedValue(isBroker, userCnpj){
        let hashedPayload = await this.hashPayloadCreation(userCnpj)
        if(isBroker)
        {
          this.putBroker(hashedPayload, userCnpj) 
        }
        else
        {
          hashedPayload = {
            ...hashedPayload,
            cnpj:userCnpj
          }
          this.putCompany(hashedPayload)
        } 
    },    
    async getCompanyOrBrokerAcknowledgment({role, brokerId, companyCnpj})
    {
      if(role=== 'partner' || role === 'broker')
      {
        const {data} = await this.getBrokerById(brokerId)
        return Boolean(data?.hashed)
      }
      if(role === 'pro' || role === 'markets')
      {
        const {data} = await this.getCompanyByCnpj(companyCnpj)
        return Boolean(data?.hashed) 
      }
      return false
     },
    getCompanyByCnpj (cnpj) {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/company_lookup/${cnpj}`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    putBroker (data, cnpj) {
      const onlyNumberCnpj = cnpj.replace(/\D/g, '')
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/broker_update/${onlyNumberCnpj}`

      return axios.put(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getBrokerById (id) {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/broker_lookup_by_id/${id}`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    uploadBrokerLogo(brokerId, file) {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/broker_logo/${brokerId}`

      const formData = new FormData()
      formData.append("file", file)

      return axios.put(url, formData, {
        headers: {
          SECRETKEY,
          "Content-Type": "multipart/form-data"
        }
      })
    },
    getBrokerLogo(brokerId) {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/broker_logo/${brokerId}`

      return axios.get(url, {
        headers: { SECRETKEY: SECRETKEY },
        responseType: "blob"
      })
    },
    getBankById (id) {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/bank_lookup_by_id/${id}`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    putBankByCnpj(cnpj, override)
    {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/bank_update/${cnpj}`
      const isOverride = {"is_override": override}
      return axios.put(url, isOverride, {
        headers:{
          SECRETKEY: SECRETKEY
        }
      })
    },
    getBankIdList () {
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/bank_id_list`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    saveScheduledQuote (quote) {
      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/save-scheduled-quotes`

      return axios.post(url, quote, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    overwriteScheduledQuotes (quotes) {
      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/overwrite-scheduled-quotes`

      return axios.post(url, quotes, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getScheduledQuotes () {
      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/get-scheduled-quotes`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    putQuoteManual(rfqId, quoteManual, bankId) {
      const url = `${CLEARFXAI_API_URL}/${RFQ_PATH}/quote_manual/${rfqId}`

      const params = {
        bank_id: bankId,
        ...(quoteManual != null && { quote_manual: quoteManual })
      }

      return axios.put(url, null, {
        headers: { SECRETKEY },
        params
      })
    },
    getRfqsManualPrice(brokerId) {
      const url = `${CLEARFXAI_API_URL}/${RFQ_PATH}/rfqs_update_price/${brokerId}`

      return axios.get(url, {
        headers: { SECRETKEY: SECRETKEY }
      })
    },
    requestQuote(data, selectedBanks = [], selectedBanksIds = []) {
      const bankId = selectedBanksIds
      const banksParam = selectedBanks.length
        ? `?banks=${selectedBanks.map(name => name.replace(/\s+/g, '').toLowerCase()).join(",")}`
        : ""

      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-request-quote${banksParam}`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}/new?banksId=${bankId}`

      return axios.post(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getQuoteFeed(rfqId, selectedBanks = [], selectedBanksIds = [], onQuote, onError) {
      const banks = selectedBanks.map(name =>
        name.replace(/\s+/g, '').toLowerCase()
      )
      const bankId = selectedBanksIds.map(id=>id)

      const query = this.settingsStore.isMockDataOn
        ? `?banks=${banks.join(",")}`
        : `?banksId=${bankId}`

      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-quotefeed-${rfqId}${query}`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}/quotefeed/${rfqId}${query}`

      const eventSource = new EventSourcePolyfill(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })

      eventSource.addEventListener('QUOTE_EVENT', event => {
        const data = JSON.parse(event.data)
        onQuote(data)
      })

      eventSource.onerror = error => {
        eventSource.close()
        onError(error)
      }

      return eventSource
    },
    makeQuoteOrder(data) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-quote-order-${data.rfq_id}`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}/neworder/${data.rfq_id}`

      return axios.post(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    cancelQuote(data) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-cancel-quote-${data.rfq_id}`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}/cancel/${data.rfq_id}`

      return axios.post(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getIntradayOrderList(brokerCnpj, companyCnpj) {
      const url = `${CLEARFXAI_API_URL}/${RFQ_PATH}/orderlog/intraday`

      // always send broker_cnpj, only send company_cnpj if provided
      const params = { broker_cnpj: brokerCnpj }
      if (companyCnpj) params.company_cnpj = companyCnpj

      return axios.get(url, {
        headers: { SECRETKEY: SECRETKEY },
        params
      })
    },
    getRfqDocument(rfq_id, doctype) {
      const base = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}`

      const url = `${base}/documents/${rfq_id}/${doctype}`

      return axios.get(url, {
        headers: { SECRETKEY: SECRETKEY },
        responseType: "blob"  // IMPORTANT: receives file correctly (PDF, CSV, PPTX, etc.)
      })
    },
    uploadRfqDocument(rfq_id, doctype, file) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/documents/${rfq_id}?doctype=${doctype}`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}/documents/${rfq_id}?doctype=${doctype}`

      const formData = new FormData()
      formData.append("file", file)
      const arr = JSON.parse(localStorage.getItem('fileId')) || []
      arr.push(rfq_id)
      localStorage.setItem('fileId', JSON.stringify(arr))
      
      return axios.put(url, formData, {
        headers: {
          SECRETKEY,
          "Content-Type": "multipart/form-data"
        }
      })
    },
    getRfqListWithDocument() {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/documents/rfqs`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}/documents/rfqs`

      return axios.get(url, {
        headers: { SECRETKEY: SECRETKEY }
      })
    },
    deleteOperation(operation_id) {
      const base = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}`

      const url = `${base}/operations/${operation_id}`

      return axios.delete(url, {
        headers: { SECRETKEY }
      })
    },
    async downloadOperation(operationIds) {
      const doctypes = [
        "invoice",
        "import_declaration",
        "proof_of_import",
        "bill_of_lading"
      ]

      if (!operationIds.length || !doctypes.length) return

      for (const operationId of operationIds) {
        for (const doctype of doctypes) {
          try {
            const response = await this.getOperation(operationId, doctype)

            const filename = `${operationId}_${doctype}.pdf`

            const url = window.URL.createObjectURL(response.data)
            const link = document.createElement("a")
            link.href = url
            link.download = filename
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)

          } catch (err) {
            console.log(err)
          }
        }
      }
    },
    getOperation(operation_id, doctype) {
      const base = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}`
        : `${CLEARFXAI_API_URL}/${RFQ_PATH}`

      const url = `${base}/operations/${operation_id}/${doctype}`

      return axios.get(url, {
        headers: { SECRETKEY: SECRETKEY },
        responseType: "blob"  // IMPORTANT: receives file correctly (PDF, CSV, PPTX, etc.)
      })
    },
    getAmlCheck(operationId){
        const url = `${CLEARFXAI_API_URL}/${RFQ_PATH}/operations/get_aml_check/${operationId}`
        
        return axios.get(url, {
        headers: {
          SECRETKEY
        }
      })
    },
    updateAmlCheck(operationId, wasChecked){
       const url = `${CLEARFXAI_API_URL}/${RFQ_PATH}/operations/update_aml_check/${operationId}`

       return axios.put(url, null, {
        headers: {
          SECRETKEY,
          "Content-Type": "multipart/form-data"
        },
          params : {
          was_checked : wasChecked
        }
      })
    },
    uploadOperation(alias, doctype, file, amlCheck, operation_id = null, client_id = null) {
      const broker_id = localStorage.getItem('brokerId')
      let company_id = localStorage.getItem('companyId')
      if(client_id){
        company_id = client_id
      }

      const basePath = this.settingsStore.isMockDataOn
        ? SANDBOX_PATH
        : RFQ_PATH

      const params = new URLSearchParams({
        alias,
        broker_id,
        aml_check : amlCheck,
        doctype
      })

      if (operation_id) {
        params.append("operation_id", operation_id)
      }

      if (company_id && company_id !== 'null') {
        params.append("company_id", company_id)
      }

      const url = `${CLEARFXAI_API_URL}/${basePath}/operations?${params.toString()}`

      const formData = new FormData()
      formData.append("file", file)
      return axios.put(url, formData, {
        headers: {
          SECRETKEY,
          "Content-Type": "multipart/form-data"
        }
      })
    },
    getOperationIdList() {
      const broker_id = localStorage.getItem('brokerId')
      const company_id = localStorage.getItem('companyId')

      const basePath = this.settingsStore.isMockDataOn
        ? SANDBOX_PATH
        : RFQ_PATH

      const params = new URLSearchParams({
        broker_id
      })

      if (company_id && company_id !== 'null') {
        params.append("company_id", company_id)
      }

      const url = `${CLEARFXAI_API_URL}/${basePath}/operations/intraday?${params.toString()}`

      return axios.get(url, {
        headers: {
          SECRETKEY
        }
      })
    },
    putOperationWithRfq (rfq_id, operation_id) {
      const url = `${CLEARFXAI_API_URL}/${RFQ_PATH}/operations_rfq`

      return axios.put(url, null, {
        headers: { SECRETKEY: SECRETKEY },
        params: {
          rfq_id: rfq_id,
          operation_id: operation_id
        }
      })
    },
    getMockIntradayOrderList(data) {
      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-intraday-order-list`

      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        },
        params: data
      })
    },
    getMockBanks () {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/mock-banks`
        : ''
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getBrokerClients (brokerId) {
      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/get-clients`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        },
        params: {
          mockOn: this.settingsStore.isMockDataOn,
          broker_id: brokerId
        }
      })
    },
    saveBrokerClients (clients, brokerId) {
      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/save-clients`
      return axios.post(url, {
        clients: clients
      }, {
        headers: {
          SECRETKEY: SECRETKEY
        },
        params: {
          mockOn: this.settingsStore.isMockDataOn,
          broker_id: brokerId
        }
      })
    },
    sendEmail({ type, brokerEmail, clientEmail, quoteData, mailCase }) {
      let endpoint = ''

      if (type === 'scheduled') {
        endpoint = 'send-scheduled-quote'
      } else if (type === 'approval') {
        endpoint = 'send-quote-approval-request'
      } else if (type === 'login') {
        endpoint = 'send-login-credentials'
      } else {
        endpoint = 'send-quote-confirmation'
      }


      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/${endpoint}`

      const body = {
        broker_email: brokerEmail,
        client_email: clientEmail,
        quote_data: quoteData
      }

      if (endpoint === 'send-quote-confirmation') {
        body.case = mailCase
      }

      return axios.post(url, body, {
        headers: { SECRETKEY: SECRETKEY }
      })
    },
    saveReports (data) {
      const url = this.settingsStore.isMockDataOn
       ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/save-reports`
       : `${CLEARFXAI_API_URL}/${REPORT_PATH}/save-reports`
      return axios.post(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getReports (sourceMockedOff, sourceMockedOn) {
      const url = this.settingsStore.isMockDataOn
       ? `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/get-reports`
       : `${CLEARFXAI_API_URL}/${REPORT_PATH}/get-reports`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        },
        params: this.settingsStore.isMockDataOn
        ? {source: sourceMockedOn}
        : sourceMockedOff
      })
    },
//disable rfq_quote when toggling button
    toggleClientStatusBackEnd(cnpj, blocked)
    {
      const onlyNumberCnpj = cnpj.replace(/\D/g, '')
      const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/company_update/${onlyNumberCnpj}`


      //updates blocked from DB when user toggles pressed button
      return axios.put(url,{blocked:blocked},{
        headers:{SECRETKEY:SECRETKEY}
      }).then().catch(err=>{throw err})
    }
  }
})

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    visible: false,
    message: '',
    color: 'success',
    timeout: 3000
  }),
  actions: {
    open (message, color = 'success', timeout = 3000) {
      this.message = message
      this.color = color
      this.timeout = timeout
      this.visible = true
    },
    close () {
      this.visible = false
    }
  }
})

export const useAutopricerStore = defineStore("autopricer", {
  state: () => ({
    settingsStore: useSettingsStore()
  }),
  actions: {
    getMarketData (bankId) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/autopricer-marketdata`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/autopricer-marketdata?bankId=${bankId}`
      return axios.get(url)
    },
    putCasado (side, field, value, bankId) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/autopricer-casado`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/autopricer-casado?bankId=${bankId}`
      return axios.put(url, { side, field, value }, {
      })
    },
    getDealEmailAddress () {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/deal-email-address`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/get-deal-email-address`
      return axios.get(url)
    },
    putDealEmailAddress (payload) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/deal-email-address`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/put-deal-email-address`
      return axios.put(url, payload)
    },
    getDealCount (bankId) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/dealcount`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/get-deal-count?bankId=${bankId}`
      return axios.get(url)
    },
    getSpreadsCategory () {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/spreads-category`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/get-spreads-category`
      return axios.get(url)
    },
    putSpreadsCategory (payload) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/spreads-category`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/put-spreads-category`
      return axios.put(url, payload)
    },
    getSpreadsNotional () {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/spreads-notional`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/get-spreads-notional`
      return axios.get(url)
    },
    putSpreadsNotional (payload) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/spreads-notional`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/put-spreads-notional`
      return axios.put(url, payload)
    },
    getRfqs (bankId) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_PRICER_PATH}/rfqs`
        : `${CLEARFXAI_API_URL}/${PRICER_PATH}/get-rfqs?bankId=${bankId}`
      return axios.get(url)
    },
  }
})

export const useConsoleApiStore = defineStore("consoleApi", {
  state: () => ({
    settingsStore: useSettingsStore(),
    requestCount: 0,
    alerts: {},
    apiKey: "",
  }),
  actions: {
    async fetchRequestCount () {
      try {   
        const url = this.settingsStore.isMockDataOn
          ? `${CLEARFXAI_API_URL}/${MOCK_CONSOLE_PATH}/mock-request-count`
          : `${CLEARFXAI_API_URL}/${CONSOLE_PATH}/mock-request-count`
        const response = await axios.get(url)
        this.requestCount = response.data.requests_count
      } catch (error) {
        console.log(error)
      }
    },

    async fetchAlerts () {
      try {
        const url = this.settingsStore.isMockDataOn
          ? `${CLEARFXAI_API_URL}/${MOCK_CONSOLE_PATH}/mock-liquidity-providers-alerts`
          : `${CLEARFXAI_API_URL}/${CONSOLE_PATH}/mock-liquidity-providers-alerts`
        const response = await axios.get(url)
        this.alerts = response.data
      } catch (error) {
        console.log(error)
      }
    },

    async fetchApiKey () {
      try {
        const url = this.settingsStore.isMockDataOn
          ? `${CLEARFXAI_API_URL}/${MOCK_CONSOLE_PATH}/apikey`
          : `${CLEARFXAI_API_URL}/${CONSOLE_PATH}/apikey`
        const response = await axios.get(url)
        this.apiKey = response.data.apikey
      } catch (error) {
        console.error(error)
      }
    },

    async refreshApiKey (currentApiKey) {
      try {
        const url = this.settingsStore.isMockDataOn
          ? `${CLEARFXAI_API_URL}/${MOCK_CONSOLE_PATH}/apikey-refresh?currentapikey=${currentApiKey}`
          : `${CLEARFXAI_API_URL}/${CONSOLE_PATH}/apikey-refresh?currentapikey=${currentApiKey}`
        const response = await axios.put(url)
        this.apiKey = response.data.apikey
      } catch (error) {
        console.error(error)
      }
    },
  }
})

export const useTlsStore = defineStore("tls", {
  state: () => ({
    settingsStore: useSettingsStore(),
    tlsList: []
  }),
  getters: {
    // tlsListGetter(state) {
    //   const tlsList = state.tlsList
    //   const tlsListLength = tlsList.length
    //   for (let i=0; i < tlsListLength; i++) {
    //     tlsList[i] = JSON.parse(tlsList[i])
    //   }
    //   return tlsList
    // }
  },
  actions: {
    async getTLSList (active=1) {
      try {
        const url = this.settingsStore.isMockDataOn
          ? `${CLEARFXAI_API_URL}/${MOCK_TLS_PATH}/list`
          : `${CLEARFXAI_API_URL}/${TLS_PATH}/list`
        const response = await axios.get(url, {
          headers: { "APIKEY": APIKEY },
          params: {
            active: active
          },
        })
        const data = response.data
        const jsonData = JSON.parse(JSON.stringify(data))
        let tlsList = []
        if (jsonData.content !== "") {
          tlsList = JSON.parse(jsonData.content.replaceAll("'", ""))
        }
        this.tlsList = tlsList
      } catch (error) {
        console.log(error)
      } 
    },
    downloadTLS (tlsId) {
      const url = this.settingsStore.isMockDataOn
        ? `${CLEARFXAI_API_URL}/${MOCK_TLS_PATH}/get`
        : `${CLEARFXAI_API_URL}/${TLS_PATH}/get`
      return axios.get(url, {
        headers: { "APIKEY": APIKEY },
        params: {
          hash_code: tlsId
        },
        responseType: "arraybuffer"
      })
    }
  },
})
